<script>
import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: {
    width: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: null,
    },
    doughnut_data: {
      type: Array,
      default: null,
    },
    reRender: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      gradient: "",
      gradient2: "",
      options: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        responsive: true,
        legend: {
          display: false,
          position: "right",
          align: "center",
          labels: {
            padding: 20,
            fontSize: 11,
            boxWidth: 20,
            usePointStyle: true,
          },
        },
      },
    };
  },
  computed: {
    datas() {
      return {
        labels: ["女性", "男性"],
        datasets: [
          {
            data: this.doughnut_data,
            backgroundColor: [this.gradient, this.gradient2],
          },
        ],
      };
    },
  },
  mounted() {
    this.graphColor();
    this.renderChart(this.datas, this.options);
  },
  methods: {
    graphColor() {
      var gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 175);
      gradient.addColorStop(0, "#fa7686");
      gradient.addColorStop(1, "#fa768666");
      var gradient2 = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 175);
      gradient2.addColorStop(0, "#0095f6");
      gradient2.addColorStop(1, "#6DD3F1");
      this.gradient = gradient
      this.gradient2 = gradient2
    },
  },
  watch: {
    doughnut_data() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
    reRender() {
      this.graphColor();
      this.renderChart(this.datas, this.options);
    },
  },
};
</script>
